import { MCity, MState } from '@Models/auth.model'
import { MIFirearm } from '@Models/client/firearm.model'

export class MInsurance {
    address: string

    carrier: string

    city: MCity | any

    code: string

    confirmationCode: string

    coverage: string

    endedAt: string

    files: any[]

    id: string

    items: MIFirearm[]

    phone: string

    policy: string

    startedAt: string

    state: MState | any

    status: string

    userId: string

    zip: string

    constructor(insurance: MInsurance) {
        this.address = insurance?.address
        this.carrier = insurance?.carrier
        this.city = insurance?.city?.code
        this.code = insurance?.code
        this.confirmationCode = insurance?.confirmationCode
        this.coverage = insurance?.coverage
        this.endedAt = insurance?.endedAt || ''
        this.startedAt = insurance?.startedAt || ''
        this.files = insurance?.files
        this.id = insurance?.id
        this.items = insurance?.items
        this.phone = insurance?.phone
        this.policy = insurance?.policy
        this.startedAt = insurance?.startedAt
        this.state = insurance?.state?.code
        this.status = insurance?.status
        this.userId = insurance?.userId
        this.zip = insurance?.zip
    }
}
